/* eslint-disable no-param-reassign */
import { SystemFuncArgs } from '@brochington/ecstatic';
import { Components } from 'editor/components';
import Canvas from 'editor/components/Canvas';

export const prepareCanvasComponents = [Canvas];

export function prepareCanvas(args: SystemFuncArgs<Components>): void {
  const { components } = args;

  const canvasComp = components.get(Canvas);
  const { canvas, monitorResize, clear } = canvasComp;

  if (monitorResize) {
    // NOTE: Right now it seems that devicePixelRatio doesn't need to be incorporated here.
    //       This might need to change in the future.
    const displayWidth = canvas.clientWidth;
    const displayHeight = canvas.clientHeight;

    if (canvas.width !== displayWidth || canvas.height !== displayHeight) {
      canvas.width = displayWidth;
      canvas.height = displayHeight;
    }
  }

  if (clear) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
  }
}
